import Chat from './Chat.page';

export default Chat;
